import { ApiClient } from "../api-client";
import schemaValidators from "./schema-validators";

export class ConnectionCheckClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClient["config"]) {
		super(config, schemaValidators);
	}

	async #badConnectionCheck(uploadBitSize = 8e7, timeout = 5000) {
		const data = new Blob(["0".repeat(uploadBitSize)]);
		//@ts-ignore
		if (globalThis.XMLHttpRequest) {
			return new Promise<number>((resolve, _reject) => {
				//@ts-ignore
				const xhr = new XMLHttpRequest();

				const connectionCheckUrl = `${this.config.verityOrigin}/connection/check`;
				let startTime: number, curTime;
				xhr.open("POST", connectionCheckUrl, true);
				xhr.timeout = timeout;
				//@ts-ignore
				xhr.upload.addEventListener("loadstart", function (ev) {
					if (ev.loaded === 0) {
						startTime = performance.now();
					}
				});
				//@ts-ignore
				xhr.upload.addEventListener("loadend", function (ev) {
					curTime = performance.now();
					resolve((ev.loaded / (curTime - startTime)) * 1000);
				});
				xhr.send(data);
			});
		} else {
			const controller = new AbortController();
			const startTime = performance.now();
			setTimeout(() => {
				uploadBitSize = NaN;
				controller.abort();
			}, timeout);
			try {
				await fetch(`${this.config.verityOrigin}/api/verity/connection/check`, {
					method: "POST",
					body: data,
					signal: controller.signal,
				});
			} catch (err) {
				if (!controller.signal.aborted) {
					throw err;
				}
			}
			const endTime = performance.now();
			return (uploadBitSize / (endTime - startTime)) * 1000;
		}
	}

	/**
	 * This connection check sucks
	 */
	check = async () => {
		return {
			metrics: {
				//@ts-ignore
				type: navigator.connection?.type,
				//@ts-ignore
				effectiveType: navigator.connection?.effectiveType,
				//@ts-ignore
				downlinkMax: navigator.connection?.downlinkMax,
				//@ts-ignore
				downlink: navigator.connection?.downlink,
				//@ts-ignore
				rtt: navigator.connection?.rtt,
			},
			uploadSpeed: await this.#badConnectionCheck(),
		};
	};
}
